var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1595 25.7425L26.1166 18.8994M26.1166 18.8994L19.1595 12.0563M26.1166 18.8994H12.2023M36.5523 18.8994C36.5523 28.3477 28.7653 36.0071 19.1595 36.0071C9.55365 36.0071 1.7666 28.3477 1.7666 18.8994C1.7666 9.45102 9.55365 1.79163 19.1595 1.79163C28.7653 1.79163 36.5523 9.45102 36.5523 18.8994Z",
    stroke: "#EDEDED",
    strokeWidth: 3.28995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrow);
export default __webpack_public_path__ + "static/media/button-arrow.45aeb8327ef0bb77c46db097bce124b9.svg";
export { ForwardRef as ReactComponent };